import { Injectable, OnDestroy } from "@angular/core";
import { FileDbEntity } from "@docma-mm-core/attachment/attachment-db.entity";
import { MmDbService } from "../../mm-db/mm-db-service";
import { MmProjectDbCollections } from "../../mm-db/mm-project-db-schema";

@Injectable()
export class SyncFileService implements OnDestroy {

  constructor(private readonly mmDbService: MmDbService) {


  }

  ngOnDestroy(): void {
  }

  async saveFile(mydocmaUid: string, file: FileDbEntity ) {
    const db = await this.mmDbService.getProjectDb(mydocmaUid);
    const entity = await db.set(MmProjectDbCollections.sync_files as never, file);
  }

  async getFile(mydocmaUid: string, fileUid: string ): Promise<FileDbEntity> {
    const db = await this.mmDbService.getProjectDb(mydocmaUid);
    return  await db.get(MmProjectDbCollections.sync_files as never, fileUid);
  }

  async removeFile(mydocmaUid: string, fileUid: string ) {
    const db = await this.mmDbService.getProjectDb(mydocmaUid);
    await db.remove(MmProjectDbCollections.sync_files as never, fileUid);
  }


}
